/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: "TermsAndConditions",
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "content-container" }, [
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _vm._m(9),
      _vm._v(" "),
      _vm._m(10),
      _vm._v(" "),
      _vm._m(11),
      _vm._v(" "),
      _c("section", [
        _c("h3", [_vm._v("10. CONTACT US")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "If you have any questions about this Terms and Conditions or our data practices, please contact us\n                at:"
          )
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", { staticStyle: { "margin-bottom": "0.5rem" } }, [
            _c("strong", [_vm._v("Email:")]),
            _vm._v(" "),
            _c("a", { attrs: { href: "mailto:einvoice@win2food.com.my" } }, [
              _vm._v("einvoice@win2food.com.my")
            ])
          ]),
          _vm._v(" "),
          _vm._m(12),
          _vm._v(" "),
          _vm._m(13)
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "By using our e-invoice digital form services, you acknowledge and agree to these Terms and\n                Conditions."
          )
        ])
      ])
    ])
  ])
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-container" }, [
      _c("h1", { staticClass: "header-title" }, [_vm._v("Terms & Conditions")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("Last Updated:")]),
      _vm._v(" 1st Jan 2025")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        'These Terms and Conditions ("Terms") govern your use of the e-invoice digital form services provided by\n            '
      ),
      _c("strong", [_vm._v("Win2 Food Marketing Sdn. Bhd")]),
      _vm._v(
        '. ("we," "us," or "our"). By providing your information to us through our\n            digital forms, you agree to comply with these Terms.'
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("1. ACCEPTANCE OF TERMS")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "By submitting your information through our e-invoice digital forms, you:"
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Confirm that the information provided is accurate and complete."
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Agree to these Terms and our Privacy Policy.")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Consent to the collection, use, and disclosure of your personal data as outlined in our Privacy\n                    Policy."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "If you do not agree to these Terms, please do not use our services."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("2. PURPOSE OF DATA COLLECTION")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "The information collected through our e-invoice digital forms is used to:"
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Comply with LHDN e-invoice requirements and other regulatory obligations."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Process and issue e-invoices for business transactions.")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Maintain accurate financial records for reporting purposes.")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("3. USER RESPONSIBILITIES")]),
      _vm._v(" "),
      _c("p", [_vm._v("When using our services, you agree to:")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("Provide Accurate Information:")]),
          _vm._v(
            " Ensure that all information you provide is true,\n                    accurate, and up to date."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Update Information:")]),
          _vm._v(
            " Notify us promptly of any changes to the information\n                    provided."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Compliance with Laws:")]),
          _vm._v(
            " Use our services in compliance with all applicable laws\n                    and regulations, including those related to tax and invoicing."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("4. DATA PROTECTION")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We handle your personal data in accordance with our Privacy Policy, which complies with the Personal\n                Data Protection Act (PDPA) 2010 of Malaysia."
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v("Your data will be used solely for the purposes stated above.")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "We employ strict security measures to protect your data from unauthorized access or misuse."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("5. DISCLAIMER OF LIABILITY")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("Accuracy of Information:")]),
          _vm._v(
            " While we strive to ensure accurate processing of your\n                    e-invoice, you are responsible for the accuracy of the data submitted. We are not liable for\n                    errors caused by incorrect or incomplete information provided by you."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Service Interruptions:")]),
          _vm._v(
            " We are not responsible for any delays, interruptions, or\n                    technical issues that may affect the availability of our digital forms or e-invoice services.\n                "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Third-Party Services:")]),
          _vm._v(
            " We are not liable for any issues arising from third-party\n                    services used in the processing of e-invoices, such as governmental portals or software\n                    providers."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("6. TERMINATION OF SERVICE")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We reserve the right to suspend or terminate your access to our services if:"
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("You violate these Terms.")]),
        _vm._v(" "),
        _c("li", [_vm._v("You provide false or misleading information.")]),
        _vm._v(" "),
        _c("li", [_vm._v("Required by legal or regulatory authorities.")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("7. INTELLECTUAL PROPERTY")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "All content and materials related to our e-invoice digital forms, including text, graphics, and\n                software, are owned by or licensed to Win2 Food Marketing Sdn. Bhd. You may not reproduce,\n                distribute, or use any materials without our prior written consent."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("8. GOVERNING LAW")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "These Terms are governed by and construed in accordance with the laws of Malaysia. Any disputes\n                arising under or related to these Terms shall be subject to the exclusive jurisdiction of the courts\n                in Malaysia."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("9. CHANGES TO THESE TERMS")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We reserve the right to modify these Terms at any time. Any updates will be posted on our website,\n                and where appropriate, communicated via email or other channels. Continued use of our services\n                constitutes your acceptance of the revised Terms."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticStyle: { "margin-bottom": "0.5rem" } }, [
      _c("strong", [_vm._v("Postal Address:")]),
      _vm._v(
        " No.6, Jalan Tahana, Kawasan\n                    Perindustrian Tampoi, 81200 Johor Bahru, Johor, Malaysia."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticStyle: { "margin-bottom": "0.5rem" } }, [
      _c("strong", [_vm._v("Phone:")]),
      _vm._v(" +607-235 1103 (Hunting Line)")
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-c4ac50e8_0", { source: "\n.header-container[data-v-c4ac50e8] {\r\n    text-align: center;\r\n    background-color: #3663e6;\r\n    padding: 20px;\r\n    max-width: 1200px;\r\n    margin: 3rem auto 0 auto;\r\n    border-top-left-radius: 1rem;\r\n    border-top-right-radius: 1rem;\n}\n.header-title[data-v-c4ac50e8] {\r\n    color: white;\n}\n.content-container[data-v-c4ac50e8] {\r\n    background: white;\r\n    padding: 20px 50px;\r\n    max-width: 1200px;\r\n    margin: 0rem auto 3rem auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    border-bottom-left-radius: 1rem;\r\n    border-bottom-right-radius: 1rem;\n}\nh1[data-v-c4ac50e8],\r\nh3[data-v-c4ac50e8] {\r\n    margin: 1rem 0;\r\n    color: black;\n}\nul[data-v-c4ac50e8] {\r\n    margin: 0;\r\n    padding: 0 0 0 20px;\n}\nli[data-v-c4ac50e8] {\r\n    margin-bottom: 1rem;\n}\na[data-v-c4ac50e8] {\r\n    color: #007bff;\r\n    text-decoration: none;\n}\na[data-v-c4ac50e8]:hover {\r\n    text-decoration: underline;\n}\np[data-v-c4ac50e8] {\r\n    text-align: justify;\n}\n@media (max-width: 575.99px) {\n.header-container[data-v-c4ac50e8] {\r\n        margin: 1.5rem 2rem 0 2rem;\n}\n.content-container[data-v-c4ac50e8] {\r\n        font-size: 0.875rem;\r\n        margin: 0rem 2rem 1.5rem 2rem;\r\n        padding: 20px 30px;\n}\nh1[data-v-c4ac50e8] {\r\n        font-size: 2.5rem;\n}\nli[data-v-c4ac50e8] {\r\n        margin-bottom: 0.75rem;\n}\n}\r\n", map: {"version":3,"sources":["../myinvois/myinvois/public/js/terms_and_conditions/Home.vue"],"names":[],"mappings":";AAgIA;IACA,kBAAA;IACA,yBAAA;IACA,aAAA;IACA,iBAAA;IACA,wBAAA;IACA,4BAAA;IACA,6BAAA;AACA;AAEA;IACA,YAAA;AACA;AAEA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;IACA,2BAAA;IACA,aAAA;IACA,sBAAA;IACA,yCAAA;IACA,+BAAA;IACA,gCAAA;AACA;AAEA;;IAEA,cAAA;IACA,YAAA;AACA;AAEA;IACA,SAAA;IACA,mBAAA;AACA;AAEA;IACA,mBAAA;AACA;AAEA;IACA,cAAA;IACA,qBAAA;AACA;AAEA;IACA,0BAAA;AACA;AAEA;IACA,mBAAA;AACA;AAEA;AACA;QACA,0BAAA;AACA;AAEA;QACA,mBAAA;QACA,6BAAA;QACA,kBAAA;AACA;AAEA;QACA,iBAAA;AACA;AAEA;QACA,sBAAA;AACA;AAEA","file":"Home.vue","sourcesContent":["<template>\r\n    <div>\r\n        <div class=\"header-container\">\r\n            <h1 class=\"header-title\">Terms & Conditions</h1>\r\n        </div>\r\n        <div class=\"content-container\">\r\n            <p><strong>Last Updated:</strong> 1st Jan 2025</p>\r\n            <p>These Terms and Conditions (\"Terms\") govern your use of the e-invoice digital form services provided by\r\n                <strong>Win2 Food Marketing Sdn. Bhd</strong>. (\"we,\" \"us,\" or \"our\"). By providing your information to us through our\r\n                digital forms, you agree to comply with these Terms.</p>\r\n\r\n            <section>\r\n                <h3>1. ACCEPTANCE OF TERMS</h3>\r\n                <p>By submitting your information through our e-invoice digital forms, you:</p>\r\n                <ul>\r\n                    <li>Confirm that the information provided is accurate and complete.</li>\r\n                    <li>Agree to these Terms and our Privacy Policy.</li>\r\n                    <li>Consent to the collection, use, and disclosure of your personal data as outlined in our Privacy\r\n                        Policy.</li>\r\n                </ul>\r\n                <p>If you do not agree to these Terms, please do not use our services.</p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>2. PURPOSE OF DATA COLLECTION</h3>\r\n                <p>The information collected through our e-invoice digital forms is used to:</p>\r\n                <ul>\r\n                    <li>Comply with LHDN e-invoice requirements and other regulatory obligations.</li>\r\n                    <li>Process and issue e-invoices for business transactions.</li>\r\n                    <li>Maintain accurate financial records for reporting purposes.</li>\r\n                </ul>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>3. USER RESPONSIBILITIES</h3>\r\n                <p>When using our services, you agree to:</p>\r\n                <ul>\r\n                    <li><strong>Provide Accurate Information:</strong> Ensure that all information you provide is true,\r\n                        accurate, and up to date.</li>\r\n                    <li><strong>Update Information:</strong> Notify us promptly of any changes to the information\r\n                        provided.</li>\r\n                    <li><strong>Compliance with Laws:</strong> Use our services in compliance with all applicable laws\r\n                        and regulations, including those related to tax and invoicing.</li>\r\n                </ul>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>4. DATA PROTECTION</h3>\r\n                <p>We handle your personal data in accordance with our Privacy Policy, which complies with the Personal\r\n                    Data Protection Act (PDPA) 2010 of Malaysia.</p>\r\n                <ul>\r\n                    <li>Your data will be used solely for the purposes stated above.</li>\r\n                    <li>We employ strict security measures to protect your data from unauthorized access or misuse.</li>\r\n                </ul>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>5. DISCLAIMER OF LIABILITY</h3>\r\n                <ul>\r\n                    <li><strong>Accuracy of Information:</strong> While we strive to ensure accurate processing of your\r\n                        e-invoice, you are responsible for the accuracy of the data submitted. We are not liable for\r\n                        errors caused by incorrect or incomplete information provided by you.</li>\r\n                    <li><strong>Service Interruptions:</strong> We are not responsible for any delays, interruptions, or\r\n                        technical issues that may affect the availability of our digital forms or e-invoice services.\r\n                    </li>\r\n                    <li><strong>Third-Party Services:</strong> We are not liable for any issues arising from third-party\r\n                        services used in the processing of e-invoices, such as governmental portals or software\r\n                        providers.</li>\r\n                </ul>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>6. TERMINATION OF SERVICE</h3>\r\n                <p>We reserve the right to suspend or terminate your access to our services if:</p>\r\n                <ul>\r\n                    <li>You violate these Terms.</li>\r\n                    <li>You provide false or misleading information.</li>\r\n                    <li>Required by legal or regulatory authorities.</li>\r\n                </ul>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>7. INTELLECTUAL PROPERTY</h3>\r\n                <p>All content and materials related to our e-invoice digital forms, including text, graphics, and\r\n                    software, are owned by or licensed to Win2 Food Marketing Sdn. Bhd. You may not reproduce,\r\n                    distribute, or use any materials without our prior written consent.</p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>8. GOVERNING LAW</h3>\r\n                <p>These Terms are governed by and construed in accordance with the laws of Malaysia. Any disputes\r\n                    arising under or related to these Terms shall be subject to the exclusive jurisdiction of the courts\r\n                    in Malaysia.</p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>9. CHANGES TO THESE TERMS</h3>\r\n                <p>We reserve the right to modify these Terms at any time. Any updates will be posted on our website,\r\n                    and where appropriate, communicated via email or other channels. Continued use of our services\r\n                    constitutes your acceptance of the revised Terms.</p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>10. CONTACT US</h3>\r\n                <p>If you have any questions about this Terms and Conditions or our data practices, please contact us\r\n                    at:</p>\r\n                <ul>\r\n                    <li style=\"margin-bottom: 0.5rem;\"><strong>Email:</strong> <a\r\n                            :href=\"`mailto:einvoice@win2food.com.my`\">einvoice@win2food.com.my</a></li>\r\n                    <li style=\"margin-bottom: 0.5rem;\"><strong>Postal Address:</strong> No.6, Jalan Tahana, Kawasan\r\n                        Perindustrian Tampoi, 81200 Johor Bahru, Johor, Malaysia.</li>\r\n                    <li style=\"margin-bottom: 0.5rem;\"><strong>Phone:</strong> +607-235 1103 (Hunting Line)</li>\r\n                </ul>\r\n                <p>By using our e-invoice digital form services, you acknowledge and agree to these Terms and\r\n                    Conditions.</p>\r\n            </section>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n\r\n<script>\r\nexport default {\r\n    name: \"TermsAndConditions\",\r\n};\r\n</script>\r\n\r\n<style scoped>\r\n.header-container {\r\n    text-align: center;\r\n    background-color: #3663e6;\r\n    padding: 20px;\r\n    max-width: 1200px;\r\n    margin: 3rem auto 0 auto;\r\n    border-top-left-radius: 1rem;\r\n    border-top-right-radius: 1rem;\r\n}\r\n\r\n.header-title {\r\n    color: white;\r\n}\r\n\r\n.content-container {\r\n    background: white;\r\n    padding: 20px 50px;\r\n    max-width: 1200px;\r\n    margin: 0rem auto 3rem auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    border-bottom-left-radius: 1rem;\r\n    border-bottom-right-radius: 1rem;\r\n}\r\n\r\nh1,\r\nh3 {\r\n    margin: 1rem 0;\r\n    color: black;\r\n}\r\n\r\nul {\r\n    margin: 0;\r\n    padding: 0 0 0 20px;\r\n}\r\n\r\nli {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\na {\r\n    color: #007bff;\r\n    text-decoration: none;\r\n}\r\n\r\na:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\np {\r\n    text-align: justify;\r\n}\r\n\r\n@media (max-width: 575.99px) {\r\n    .header-container {\r\n        margin: 1.5rem 2rem 0 2rem;\r\n    }\r\n\r\n    .content-container {\r\n        font-size: 0.875rem;\r\n        margin: 0rem 2rem 1.5rem 2rem;\r\n        padding: 20px 30px;\r\n    }\r\n\r\n    h1 {\r\n        font-size: 2.5rem;\r\n    }\r\n\r\n    li {\r\n        margin-bottom: 0.75rem;\r\n    }\r\n\r\n}\r\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-c4ac50e8"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../myinvois/myinvois/public/js/terms_and_conditions/Home.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__